import emptyFieldValidate from "../../shared/empty.validate";
import mailValidate from "../../shared/mail.validate";
import matchValidate from "../../shared/match.validate";
import passwordLengthValidate from "../../shared/passwordLength.validate";
import usernameValidate from "../../shared/username.validate";

export type TErrors = {
  name: string | undefined;
  lastname: string | undefined;
  username: string | undefined;
  mail: string | undefined;
  client: string | undefined;
  projects: string | undefined;
  password: string | undefined;
  confirmpassword: string | undefined;
};

const createUser = (FormValues: Record<string, any>) => {
  let errors: TErrors = {
    name: undefined,
    lastname: undefined,
    username: undefined,
    mail: undefined,
    client: undefined,
    projects: undefined,
    password: undefined,
    confirmpassword: undefined,
  };

  errors.name = emptyFieldValidate(FormValues.name, "Name");

  errors.lastname = emptyFieldValidate(FormValues.lastname, "Last Name");

  errors.username = usernameValidate(FormValues.username);

  errors.mail = mailValidate(FormValues.mail);

  errors.password = passwordLengthValidate(FormValues.password, "Password");

  errors.confirmpassword = passwordLengthValidate(
    FormValues.confirmpassword,
    "Confirm Password"
  );

  errors.confirmpassword = matchValidate(
    FormValues.password,
    FormValues.confirmpassword
  );

  return errors;
};

export default createUser;
